import { DataCellProps } from '../types';
import { DateDiv } from 'DateModule/components/DateDiv';

export const TenantCreatedAtCell = ({ _customRowProps, tenant }: DataCellProps) => {
  return <DateDiv date={tenant.createdAt} />;
};
